import Swiper from "swiper";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";

class HomeBanner {
    constructor(element) {
        this.element = element;
        this.swiper = null;
        this.isPaused = false;
        this.pauseButton = null;

        if (!this.element) return;

        this.init();
        this.createPauseButton();
    }

    init() {
        const slides = this.element.querySelectorAll(".swiper-slide");
        const slideCount = slides.length;

        this.swiper = new Swiper(this.element, {
            modules: [Navigation, Autoplay, EffectFade],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true, // Enable loop mode
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            // speed: 1200,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                // waitForTransition: false,
                waitForTransition: true,
            },
            navigation: {
                nextEl: this.element.querySelector(".swiper-button-next"),
                prevEl: this.element.querySelector(".swiper-button-prev"),
            },
            on: {
                init: function () {
                    // console.log('Swiper initialized with', slideCount, 'slides');
                },
                slideChange: function () {
                    // console.log('Current slide:', this.realIndex + 1, 'of', slideCount);
                },
            },
        });
    }

    createPauseButton() {
        // Find the controls container
        const controlsContainer =
            this.element.querySelector(".carousel-controls");

        if (!controlsContainer) {
            // console.warn("Carousel controls container not found");
            return;
        }

        this.pauseButton = document.createElement("button");
        this.pauseButton.className =
            "swiper-button-pause btn btn--square btn--grey-to-dark-grey";
        this.pauseButton.setAttribute("aria-label", "Pause carousel");
        this.pauseButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4 0H8V24H4V0Z" fill="white"/>
            <path d="M16 0H20V24H16V0Z" fill="white"/>
        </svg>`;

        this.pauseButton.addEventListener("click", () => this.togglePause());

        // Insert at the beginning of controls container (before prev button)
        controlsContainer.insertBefore(
            this.pauseButton,
            controlsContainer.firstChild,
        );
    }

    togglePause() {
        if (this.isPaused) {
            this.swiper.autoplay.start();
            this.pauseButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M4 0H8V24H4V0Z" fill="white"/>
                <path d="M16 0H20V24H16V0Z" fill="white"/>
            </svg>`;
            this.pauseButton.setAttribute("aria-label", "Pause carousel");
        } else {
            this.swiper.autoplay.stop();
            this.pauseButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 0L20 12L6 24V0Z" fill="white"/>
            </svg>`;
            this.pauseButton.setAttribute("aria-label", "Play carousel");
        }

        this.isPaused = !this.isPaused;
    }

    destroy() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }

        if (this.pauseButton) {
            this.pauseButton.remove();
            this.pauseButton = null;
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const heroCarousel = document.querySelector(
        '[data-carousel="hero-events"]',
    );

    if (heroCarousel) {
        new HomeBanner(heroCarousel);
    }
});

export default HomeBanner;
